import { Component, OnInit, Injector } from '@angular/core';
import { MainComponent } from 'src/modules/base/components/main-component/main.component';
import { ActivatedRoute } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';


@Component({
    selector: 'app-payor-details-item-consumption',
    templateUrl: './payor-details-item-consumption.component.html',
    styleUrls: ['./payor-details-item-consumption.component.scss'],
    standalone: false
})
export class PayorDetailsItemConsumptionComponent extends MainComponent implements OnInit {
  public _currentData: any = {};

  constructor(
    public injector: Injector,
    public route: ActivatedRoute,
    public dialogConfig: DialogConfig
  ) {
    super(injector,route);
  }

  ngOnInit() {
    this._currentData.config = {
      "filterForm" : false,
      "clearOnSave": false,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this._currentData.currentData = this.dialogConfig;
    this.baseService.getResourceDef('op_item_consumption_payer_details', (resourceDef) => {
      this._currentData.resource = resourceDef.resource;
      this.getData(resourceDef);
    });
  }

  getData(resourceDef) {
    if (resourceDef) {
      this.baseService.getReferredField(resourceDef.form, (response) => {
        this._currentData._currentFormFields = {};
        this._currentData._currentFormFields.blocks = [];
        this._currentData._currentFormFields.blocks = response;
      });
    } else {
      alert('ERROR occurred, please fix');
    }

  }

  sendToParent(event) {
    console.log("Event is ",event);
    this.smartModalService.sendResult(event);
    this.dialogRef.close()
  }
}

